import { Component } from "react";
import { fabric } from "fabric";
import { Canvas } from "fabric/fabric-impl";
import Modal from "react-modal";

import "./styles.scss";
import APIService from "../Services/APIService";
import LoaderCommon from "../Loader/LoaderCommon";
import { AiOutlineCloseCircle } from "react-icons/ai";

interface Props {
  report: any;
  // logout: () => void;
}
interface State {
  signatureCanvas: fabric.Canvas;
  reportImage: string;
  customerSignature: string;
  showLoader: boolean;
  modalIsOpen: boolean;
}

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    zIndex: 10
  }
};

Modal.setAppElement("#root");
export default class Report extends Component<Props, State> {
  private service = new APIService();

  constructor(props: any) {
    super(props);

    this.state = {
      signatureCanvas: {} as Canvas,
      reportImage: "",
      customerSignature: "",
      showLoader: false,
      modalIsOpen: false
    };
  }

  componentDidMount(): void {
    this.populateData();
  }

  componentDidUpdate(prevProps: any): void {
    if (this.props?.report?.report !== prevProps?.report?.report) {
      this.populateData();
    }
  }

  async populateData() {
    this.setState({ showLoader: true });
    this.createSignatureCanvas();
    if (this.props.report) {
      await Promise.all([
        this.getImageReport(this.props.report.report),
        this.getCustomerSignatureJSON(this.props.report.customer_signature)
      ]);
      this.setState({ showLoader: false });
    }
  }

  createSignatureCanvas() {
    let signatureCanvas = this.state.signatureCanvas;
    var signatureContainer = document.getElementById("signatureContainer");

    signatureCanvas = new fabric.Canvas("signatureCanvas", {
      isDrawingMode: !this.props?.report?.is_acknowledged
    });
    signatureCanvas.setDimensions({
      width: signatureContainer!.clientWidth,
      height: 200
    });
    signatureCanvas.backgroundColor = "#F1F2F3";
    signatureCanvas.freeDrawingBrush.color = "#000000";
    signatureCanvas.freeDrawingBrush.width = 3;

    const responsive = () => {
      var width = signatureContainer!.clientWidth;
      signatureCanvas.setWidth(width);
    };
    window.addEventListener("resize", responsive);

    signatureCanvas.renderAll();

    this.setState({ signatureCanvas });
  }

  async getImageReport(name: string) {
    let res = await this.service
      .getFile(name, "report")
      .then((res) => res.blob());

    this.setState({ reportImage: URL.createObjectURL(res) });
  }

  async getCustomerSignatureJSON(name: string) {
    if (this.props.report.customer_signature) {
      let res = await this.service
        .getFile(name, "customer_signature")
        .then((res) => res.json());

      this.state.signatureCanvas.loadFromJSON(
        res,
        this.state.signatureCanvas.renderAll.bind(this.state.signatureCanvas)
      );
    }
  }

  clearSignature() {
    let signatureCanvas = this.state.signatureCanvas;

    signatureCanvas.clear();
    signatureCanvas.backgroundColor = "#F1F2F3";

    this.setState({ signatureCanvas });
  }

  async acknowledgeReport() {
    this.setState({ showLoader: true });
    try {
      let signatureCanvas = this.state.signatureCanvas;

      if (signatureCanvas.getObjects().length === 0) {
        console.warn("No objects");
        this.setState({ showLoader: false });
        return;
      }

      await Promise.all([
        this.service.updatePreInspection(
          { isAcknowledged: true },
          this.props.report.id
        ),
        this.service.sendJSONFile(
          signatureCanvas.toJSON(),
          this.props.report.id
        )
      ]);
    } catch (error) {}
    this.setState({ showLoader: false });
  }

  setIsOpen(value: boolean) {
    this.setState({ modalIsOpen: value });
  }

  openModal() {
    this.setIsOpen(true);
  }

  closeModal() {
    this.setIsOpen(false);
  }

  render() {
    return (
      <>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={() => this.closeModal()}
          style={modalStyles}
          contentLabel="Terms and Conditions - Flow Autobody"
          overlayClassName={"modal-overlay"}
        >
          <div className="terms-conditions-modal-header">
            <h2>Terms and Conditions - Flow Autobody</h2>
            <button onClick={() => this.closeModal()}>
              <AiOutlineCloseCircle width={30} height={30} />
            </button>
          </div>
          <p className="terms-conditions-modal-content">
            <b>AUTHORISATION FOR REPAIRS:</b> By signing this repair order, you
            authorise Flow Autobody to perform the repairs necessary to restore
            their vehicle to its pre-accident condition. This authorization
            includes the use of new, used, or aftermarket parts as deemed
            necessary by Flow Autobody.
            <br />
            <b>ACKNOWLEDGEMENT OF REPAIRS:</b> You acknowledge that you have
            been informed of the repairs that are required to restore yourt
            vehicle to its pre-accident condition, and agree to the repairs as
            stated on this repair order.
            <br />
            <b>ESTIMATES:</b> Estimates provided by Flow Autobody are only
            approximations and are subject to change. Any additional repairs
            required to restore your vehicle to its pre-accident condition will
            be authorised by you prior to completion of the repairs.
            <br />
            <b>PAYMENT:</b> Payment for repairs and/or insurance excess is due
            in full upon completion of the repairs. Any delay in payment may
            result in additional charges or fees. Flow Autobody reserves the
            right to retain possession of the vehicle until payment is received
            in full.
            <br />
            <b>WARRANTY:</b> Flow Autobody provides a limited warranty for all
            repairs completed. The warranty covers defects in workmanship and
            materials for a period of 12 months from the date of completion. The
            warranty is non-transferable and only applies to the original
            customer.
            <br />
            <b>LIABILITY:</b> Flow Autobody is not responsible for any loss or
            damage to personal property left in the vehicle. The customer is
            responsible for removing any personal property prior to leaving the
            vehicle with Flow Autobody.
            <br />
            <b>INSURANCE CLAIMS:</b> If the repairs are being paid for by an
            insurance company, you acknowledge that you are responsible for
            payment of any deductible and any additional charges not covered by
            the insurance company.
            <br />
            <b>ADDITIONAL REPAIRS:</b> You acknowledge that additional repairs
            may be required once work has commenced. Any additional repairs will
            be authorised by the insurance company and/or you prior to the
            completion of the repairs.
            <br />
            <b>ABANDONED VEHICLES:</b> Any vehicle left at Flow Autobody for
            more than 30 days after completion of the repairs will be considered
            abandoned and may be disposed of at the discretion of Flow Autobody.
            <br />
            <b>JURISDICTION:</b> These terms and conditions shall be governed by
            and construed in accordance with the laws of the state in which Flow
            Autobody is located. By signing below, you acknowledge that they
            have read and agree to these terms and conditions.
          </p>
        </Modal>
        {this.state.showLoader ? (
          <LoaderCommon isLoginLoader={false} loadingText={""} />
        ) : undefined}
        <div className="container">
          <img
            src={this.state.reportImage}
            alt="Pre-repair inspection report"
          />
          <p onClick={() => this.openModal()} className="open-terms-conditions">
            View full terms and conditions.
          </p>
          <div id="signatureContainer" className="signature-container">
            <canvas
              id="signatureCanvas"
              style={{
                borderRadius: "10px",
                maxWidth: "400px",
                maxHeight: "160px"
              }}
            ></canvas>
            <div className="buttons-container">
              <button
                type="button"
                className="clear-button"
                onClick={() => this.clearSignature()}
                disabled={this.props?.report?.is_acknowledged}
              >
                Clear
              </button>
              <button
                type="button"
                className="acknowledge-button"
                onClick={() => this.acknowledgeReport()}
                disabled={this.props?.report?.is_acknowledged}
              >
                Acknowledge
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}
